<template>
  <v-dialog width="500" v-model="dialog_ricerca">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined color="blue" class="mr-2"
        ><v-icon class="mr-2">mdi-magnify</v-icon>Ricerca</v-btn
      >
    </template>
    <v-card>
      <v-card-title class="grey--text text-subtitle-1"
        >Ricerca Lotto</v-card-title
      >
      <v-card-text>
        <v-row align="center">
          <v-col cols="8">
            <v-text-field
              hide-details=""
              v-model="code"
              outlined
              label="Inserisci codice prodotto"
              append-icon="mdi-camera"
              @click:append="open_scan"
              @keyup.enter="cerca()"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-btn outlined large block color="green" @click="cerca()"
              >Cerca</v-btn
            >
          </v-col>
        </v-row>
        <v-alert v-if="errore" type="error" outlined dense class="mt-3">
          {{ errore }}
        </v-alert>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text color="grey" @click="dialog_ricerca = false">Chiudi</v-btn>
      </v-card-actions>
      <v-dialog v-model="dialog_scan" width="400">
        <StreamBarcodeReader
          v-if="dialog_scan"
          ref="reader"
          @decode="(a, b, c) => onDecode(a, b, c)"
        ></StreamBarcodeReader>
      </v-dialog>
      <StoriaLottoDialog ref="storia" />
    </v-card>
  </v-dialog>
</template>

<script>
import { StreamBarcodeReader } from "vue-barcode-reader";
import StoriaLottoDialog from "./storia_lotto_dialog.vue";

export default {
  components: {
    StreamBarcodeReader,
    StoriaLottoDialog,
  },
  data() {
    return {
      dialog_ricerca: false,
      dialog_scan: false,
      code: "",
      errore: "",
    };
  },
  methods: {
    open_scan() {
      this.dialog_scan = true;
    },
    onDecode(a) {
      var audio = new Audio(require("@/assets/scan_ok.mp3"));
      audio.play();
      this.code = a;
      this.dialog_scan = false;
      this.cerca();
    },
    cerca() {
      // Il codice combina prodotto (3 lettere + 2 cifre) e lotto (2 lettere +
      // 4 cifre): es. "Tag10pl1126" → prodotto "Tag10", lotto "pl1126".
      this.errore = "";
      if (!/^[a-zA-Z]{3}[0-9]{2}[a-zA-Z]{2}[0-9]{4}$/.test(this.code)) {
        this.errore = "Codice prodotto non valido";
        return;
      }
      let prodotto = this.$store.getters.get_prodotto_by_cod(
        this.code.substring(0, 5)
      );
      if (!prodotto) {
        this.errore = "Prodotto non trovato";
        return;
      }
      let cod_lotto = this.code.substring(5, 11);
      this.$store
        .dispatch("get_lotto_by_id", cod_lotto)
        .then((lotto) => {
          let coltura = lotto.colture_associate.find(
            (c) => c.id_prodotto === prodotto.id
          );
          if (!coltura) {
            this.errore = "Nessuna coltura di questo prodotto in questo lotto";
            return;
          }
          this.$refs.storia.open(lotto.id, coltura);
        })
        .catch(() => {
          this.errore = "Lotto non trovato";
        });
    },
  },
};
</script>
